import request from '@/utils/request'

// 查询费用标准列表
export function queryHousekeepingFeeConfig(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeConfig/queryHousekeepingFeeConfig',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加费用标准
export function saveHousekeepingFeeConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeConfig/saveHousekeepingFeeConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改费用标准
export function updateHousekeepingFeeConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeConfig/updateHousekeepingFeeConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除费用标准
export function deleteHousekeepingFeeConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeConfig/deleteHousekeepingFeeConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询费用类型
export function queryHousekeepingFeeType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeType/queryHousekeepingFeeType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}